import { useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SCRIPT_ID = "plausible-analytics";

export default function usePlausible() {
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/config/public`);
        const domain = (data && data.plausible_domain) || "";
        if (!domain) return;
        if (document.getElementById(SCRIPT_ID)) return; // already mounted

        const script = document.createElement("script");
        script.id = SCRIPT_ID;
        script.defer = true;
        script.setAttribute("data-domain", domain);
        script.src = "https://plausible.io/js/script.hash.outbound-links.js";
        document.head.appendChild(script);

        // Inline queue for SPA route changes + custom events
        const q = document.createElement("script");
        q.id = SCRIPT_ID + "-queue";
        q.text = "window.plausible = window.plausible || function(){(window.plausible.q=window.plausible.q||[]).push(arguments)}";
        document.head.appendChild(q);
      } catch (e) {
        // silent — analytics never blocks UX
      }
    })();
  }, []);
}

export function trackEvent(name, props) {
  try {
    if (typeof window !== "undefined" && typeof window.plausible === "function") {
      window.plausible(name, props ? { props } : undefined);
    }
  } catch {}
}
